/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProduitAdminListItem } from './ProduitAdminListItem';
import {
    ProduitAdminListItemFromJSON,
    ProduitAdminListItemFromJSONTyped,
    ProduitAdminListItemToJSON,
    ProduitAdminListItemToJSONTyped,
} from './ProduitAdminListItem';

/**
 * 
 * @export
 * @interface GetProduitAdminListResponse
 */
export interface GetProduitAdminListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetProduitAdminListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<ProduitAdminListItem>}
     * @memberof GetProduitAdminListResponse
     */
    items: Array<ProduitAdminListItem>;
}

/**
 * Check if a given object implements the GetProduitAdminListResponse interface.
 */
export function instanceOfGetProduitAdminListResponse(value: object): value is GetProduitAdminListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetProduitAdminListResponseFromJSON(json: any): GetProduitAdminListResponse {
    return GetProduitAdminListResponseFromJSONTyped(json, false);
}

export function GetProduitAdminListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProduitAdminListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(ProduitAdminListItemFromJSON)),
    };
}

export function GetProduitAdminListResponseToJSON(json: any): GetProduitAdminListResponse {
    return GetProduitAdminListResponseToJSONTyped(json, false);
}

export function GetProduitAdminListResponseToJSONTyped(value?: GetProduitAdminListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(ProduitAdminListItemToJSON)),
    };
}

